import { gql, useMutation } from '@apollo/client';
import {
  SendNlFlashMutation,
  SendNlFlashMutationVariables,
} from '../../../__generated__/queries-newsletter';

export const SEND_NL_FLASH = gql`
  mutation SendNLFlash(
    $brandKey: BrandKey!
    $subject: String!
    $teaser: String!
    $img: String!
    $imgAlt: String!
    $title: String!
    $contentUrl: String!
    $uuid: String!
    $resource: ContentType!
  ) {
    sendNlFlash(
      brandKey: $brandKey
      subject: $subject
      teaser: $teaser
      img: $img
      imgAlt: $imgAlt
      title: $title
      contentUrl: $contentUrl
      uuid: $uuid
      resource: $resource
    )
  }
`;

export const useSendNLFlash = () => {
  const [sendNLFlash] = useMutation<
    SendNlFlashMutation,
    SendNlFlashMutationVariables
  >(SEND_NL_FLASH);

  return sendNLFlash;
};
